import { Component } from "preact";

import WidgetHeader from "./../WidgetHeader";
import WidgetBody from "./../WidgetBody";

import { validateToken } from "./../../api";

import style from "./style.scss";
import layout from "./layout.scss";

const Main = ({ closeModal, payload }) => (
  <div class={style.supportWidgetContainer} id="supportWidgetContainerId">
    <div class={style.container}>
      <WidgetHeader closeModal={closeModal} payload={payload} />
      <WidgetBody closeModal={closeModal} payload={payload} />
    </div>
  </div>
);

export default class App extends Component {
  constructor() {
    super();

    // Add widget show/hide methods
    window.SupportWidgetService = {};
    window.SupportWidgetService.showModal = this.openModal.bind(this);
    window.SupportWidgetService.hideModal = this.closeModal.bind(this);

    // Call post message when widget app is loaded
    window.parent.postMessage("PG_SUPPORT_WIDGET_LOADED", "*");

    // Handle post message events
    if (window.addEventListener) {
      window.addEventListener("message", openSupportWidget, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", openSupportWidget, false);
    }
    function openSupportWidget(event) {
      // TODO: Handle origin url check
      if (event.data && event.data.jwt && event.data.url) {
        window.SupportWidgetService.showModal(event.data);
      }
    }

    // On escape key press - close the support widget
    window.onkeydown = function (e) {
      var e = e || window.event;
      if (e.keyCode === 27) {
        // If there is any modal open on top of the widget then do not close the widget
        const fileUploaderModalId = "__filestack-picker";
        if (document.getElementById(fileUploaderModalId)) {
          return;
        }
        // Close the support widget
        window.SupportWidgetService.hideModal();
      }
    };

    this.closeModal = this.closeModal.bind(this);
    this.state = {
      show: false,
      payload: {},
      inProgress: false,
    };
  }
  refreshInterval = null;
  closeModal() {
    window.parent.postMessage("PG_SUPPORT_WIDGET_CLOSE", "*");
    this.setState({
      show: false,
      payload: {},
      inProgress: false,
    });
    clearInterval(this.refreshInterval);
  }

  refreshPolicy = () =>
    validateToken({
      token: this.state.payload.PGSupportToken,
      baseUrl: this.state.payload.PGSupportUrl,
    }).then((jwtPayload) => {
      let newPayload = this.state.payload;
      newPayload.policy = jwtPayload.policy;
      newPayload.signature = jwtPayload.signature;
      this.setState({
        payload: newPayload,
      });
    });

  openModal({
    jwt: jwtToken,
    url: baseUrl,
    logRocketUrl: logRocket,
    header,
    currentUrl,
    domainUrl,
    appError = false,
    appToken = null,
    initialPage = null,
    isStandardHub = false,
  }) {
    if (!this.state.show && !this.state.inProgress) {
      this.setState({ inProgress: true });
      validateToken({ token: jwtToken, baseUrl })
        .then((jwtPayload) => {
          jwtPayload.PGSupportToken = jwtToken;
          jwtPayload.PGSupportUrl = baseUrl;
          jwtPayload.logRocket = logRocket;
          jwtPayload.header = header;
          jwtPayload.currentUrl = currentUrl;
          jwtPayload.domainUrl = domainUrl;
          jwtPayload.appError = appError;
          jwtPayload.appToken = appToken;
          jwtPayload.initialPage = initialPage;
          jwtPayload.isStandardHub = isStandardHub;
          this.setState({
            payload: jwtPayload,
          });
          this.refreshInterval = setInterval(() => {
            this.refreshPolicy();
          }, 29 * 60000);
          setTimeout(() => {
            this.setState({
              inProgress: false,
              show: true,
            });
          }, 500);
        })
        .catch((err) => {
          console.error("Error verifying jwt token - ", err);
          this.closeModal();
          this.setState({ inProgress: false });
          alert("Server error");
        });
    }
  }

  render() {
    /**
     * In case, the iframe is open on the parent window
     * but there was no request to open the modal from it
     * then forcefully close the modal
     */
    // setTimeout(() => {
    //   if(!this.state.show && !this.state.inProgress) {
    //     window.parent.postMessage('PG_SUPPORT_WIDGET_CLOSE', '*');
    //   }
    // }, 10000);
    return (
      <div class={style.supportWidgetWrapper} align="center">
        {this.state.show ? (
          <Main closeModal={this.closeModal} payload={this.state.payload} />
        ) : (
          <div class={layout.loader}></div>
        )}
        <div id="alertModalId" style={{ display: "none" }} role="alert">
          <div class={layout.alertModal}>
            <span></span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/App/index.js